/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiSubscription, ApiSubscribe } from "../wire/ApiSubscriber";
import { WireRole } from "../wire/roles";
import type { BoardApiHandler } from "./Handler";
import {
  boardScaledEventSchema,
  iterationUpdatedEventSchema,
  noDataSchema,
  objectiveCreatedEventSchema,
  objectiveUpdatedEventSchema,
  shapeCreatedEventSchema,
  shapeDeletedEventSchema,
  shapeUpdatedEventSchema,
  stickyCreatedEventSchema,
  stickyUpdateEndedEventSchema,
  stickyUpdatedEventSchema,
  topStickyEventSchema,
} from "./schemas";

export const subscribeBoard: ApiSubscribe<BoardApiHandler> = (subscriber, variables, handler) => {
  const subscriptions = new Array<ApiSubscription>();
  if (handler.stickyCreated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky.${stickyId}.created",
          variables,
          types: { sessionId: String, boardId: String, stickyId: String },
        },
        stickyCreatedEventSchema,
        handler.stickyCreated,
        [],
      ),
    );
  }
  if (handler.stickyUpdateStarted) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky_update.${stickyId}.started",
          variables,
          types: { sessionId: String, boardId: String, stickyId: String },
        },
        noDataSchema,
        handler.stickyUpdateStarted,
        [WireRole.ADMIN, WireRole.PLANNING_INTERVAL_ADMIN, WireRole.USER],
      ),
    );
  }
  if (handler.stickyUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky.${stickyId}.updated",
          variables,
          types: { sessionId: String, boardId: String, stickyId: String },
        },
        stickyUpdatedEventSchema,
        handler.stickyUpdated,
        [WireRole.ADMIN, WireRole.PLANNING_INTERVAL_ADMIN, WireRole.USER],
      ),
    );
  }
  if (handler.stickyUpdateEnded) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky_update.${stickyId}.ended",
          variables,
          types: { sessionId: String, boardId: String, stickyId: String },
        },
        stickyUpdateEndedEventSchema,
        handler.stickyUpdateEnded,
        [WireRole.ADMIN, WireRole.PLANNING_INTERVAL_ADMIN, WireRole.USER],
      ),
    );
  }
  if (handler.stickyDeleted) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.sticky.${stickyId}.deleted",
          variables,
          types: { sessionId: String, boardId: String, stickyId: String },
        },
        noDataSchema,
        handler.stickyDeleted,
        [],
      ),
    );
  }
  if (handler.iterationUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.iteration.updated",
          variables,
          types: { sessionId: String, boardId: String },
        },
        iterationUpdatedEventSchema,
        handler.iterationUpdated,
        [],
      ),
    );
  }
  if (handler.objectiveCreated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.objectives.${objectiveId}.created",
          variables,
          types: { sessionId: String, boardId: String, objectiveId: String },
        },
        objectiveCreatedEventSchema,
        handler.objectiveCreated,
        [WireRole.ADMIN, WireRole.PLANNING_INTERVAL_ADMIN, WireRole.USER],
      ),
    );
  }
  if (handler.objectiveDeleted) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.objectives.${objectiveId}.deleted",
          variables,
          types: { sessionId: String, boardId: String, objectiveId: String },
        },
        noDataSchema,
        handler.objectiveDeleted,
        [WireRole.ADMIN, WireRole.PLANNING_INTERVAL_ADMIN, WireRole.USER],
      ),
    );
  }
  if (handler.objectiveUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.objectives.${objectiveId}.updated",
          variables,
          types: { sessionId: String, boardId: String, objectiveId: String },
        },
        objectiveUpdatedEventSchema,
        handler.objectiveUpdated,
        [WireRole.ADMIN, WireRole.PLANNING_INTERVAL_ADMIN, WireRole.USER],
      ),
    );
  }
  if (handler.shapeCreated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.shape.created",
          variables,
          types: { sessionId: String, boardId: String },
        },
        shapeCreatedEventSchema,
        handler.shapeCreated,
        [],
      ),
    );
  }
  if (handler.shapeUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.shape.updated",
          variables,
          types: { sessionId: String, boardId: String },
        },
        shapeUpdatedEventSchema,
        handler.shapeUpdated,
        [],
      ),
    );
  }
  if (handler.shapeDeleted) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.shape.deleted",
          variables,
          types: { sessionId: String, boardId: String },
        },
        shapeDeletedEventSchema,
        handler.shapeDeleted,
        [],
      ),
    );
  }
  if (handler.scaleUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.scale.updated",
          variables,
          types: { sessionId: String, boardId: String },
        },
        boardScaledEventSchema,
        handler.scaleUpdated,
        [WireRole.ADMIN, WireRole.PLANNING_INTERVAL_ADMIN, WireRole.USER],
      ),
    );
  }
  if (handler.topStickyUpdated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.board.v1.sessions.${sessionId}.boards.${boardId}.top_sticky.updated",
          variables,
          types: { sessionId: String, boardId: String },
        },
        topStickyEventSchema,
        handler.topStickyUpdated,
        [WireRole.ADMIN, WireRole.PLANNING_INTERVAL_ADMIN, WireRole.USER],
      ),
    );
  }
  return subscriptions;
};
